// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Speakers/speakers.scss
// module id = 615
// module chunks = 0